import React, { useState } from "react";
import Button from "../../button/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation, faTrashAlt } from "@fortawesome/pro-regular-svg-icons";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import UserfulConfirmationDialog from "../UserfulConfirmationDialog";
import Input from "../../Input/Input";
import { NetworkConnectionProfile } from "userful-chronos-app-common-js/dist/models/config/networkConnections";
import { UserfulTooltip } from "../..";

interface IProps {
    connections: NetworkConnectionProfile[];
    type: "dropdown" | "button";
    onDelete: (e) => void;
    addiotnalSecurity?: boolean;
    open?: boolean;
    onOpenChange?: (open: boolean) => void;
    hideTrigger?: boolean;
}

export default function DeleteConnections(props: IProps) {
    const { t } = useTranslation();

    const isControlled = props.open !== undefined;
    const [showInternal, setShowInternal] = useState(false);
    const show = isControlled ? !!props.open : showInternal;
    const [input, setInput] = useState<string>("");

    if (props.connections.length === 0) return null;

    const additionalConnections = props.connections.length - 1;

    const setShowState = (next: boolean) => {
        if (isControlled) {
            props.onOpenChange?.(next);
        } else {
            setShowInternal(next);
        }
    };

    return (
        <>
            {!props.hideTrigger && props.type === "dropdown" && (
                <Dropdown.Item onClick={(e) => setShowState(true)}>
                    <div className="userful-icon-dropdown-menu-icon-container">
                        <FontAwesomeIcon icon={faTrashAlt} />
                    </div>
                    <p>{additionalConnections > 1 ? t("Shared.deleteAll") : t("Shared.delete")}</p>
                </Dropdown.Item>
            )}
            {!props.hideTrigger && props.type === "button" && (
                <UserfulTooltip title={additionalConnections > 1 ? t("Shared.deleteAll") : t("Shared.delete")}>
                    <Button variant="secondary" iconOnly onClick={() => setShowState(true)}>
                        <FontAwesomeIcon icon={faTrashAlt} />
                    </Button>
                </UserfulTooltip>
            )}

            <UserfulConfirmationDialog
                show={show}
                icon={{ icon: faCircleExclamation, color: "#D13E2C" }}
                onCancel={() => setShowState(false)}
                title={
                    t("Shared.delete") + " " + additionalConnections ? t("Shared.connections") : t("Shared.connection")
                }
                replaceBody={
                    <>
                        <p>
                            {t("Shared.deleteStart")} <strong>{props.connections[0].id.value}</strong>
                            {additionalConnections > 0 && (
                                <strong className="userful-tag">+{additionalConnections}</strong>
                            )}
                            ? {t("Shared.deleteEnd")}
                        </p>
                        {props.addiotnalSecurity && (
                            <>
                                <Input
                                    filedTitle={t("Shared.deleteConfirmation")}
                                    value={input}
                                    onChange={(e) => {
                                        setInput(e.target.value);
                                    }}
                                />
                            </>
                        )}
                    </>
                }
                replaceFooter={
                    <>
                        <Button variant="secondary" onClick={() => setShowState(false)}>
                            {t("Shared.cancel")}
                        </Button>
                        <Button
                            variant="danger"
                            disabled={props.addiotnalSecurity && input !== "DELETE"}
                            onClick={(e) => {
                                props.onDelete(e);
                                setShowState(false);
                            }}
                        >
                            {additionalConnections > 0 ? t("Shared.deleteAll") : t("Shared.delete")}
                        </Button>
                    </>
                }
            />
        </>
    );
}
